import React from "react";

const SECTIONS = [
  {
    title: "Éditeur du site",
    items: [
      { label: "Nom de la plateforme", value: "PixyQuiz" },
      { label: "Statut", value: "A compléter par le client" },
      { label: "Adresse", value: "A compléter par le client" },
      { label: "Email de contact", value: "A compléter par le client" },
      { label: "Directeur de publication", value: "A compléter par le client" },
    ],
  },
  {
    title: "Hébergement",
    items: [
      { label: "Hébergeur", value: "A compléter par le client" },
      { label: "Adresse", value: "A compléter par le client" },
      { label: "Site web", value: "A compléter par le client" },
    ],
  },
  {
    title: "Propriété intellectuelle",
    items: [
      {
        label: "Contenus",
        value:
          "L'ensemble des contenus présentés sur PixyQuiz (textes, images, logos, graphismes, sons) est protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation est interdite.",
      },
    ],
  },
  {
    title: "Données personnelles",
    items: [
      {
        label: "Responsable du traitement",
        value:
          "Les données personnelles collectées sur ce site sont traitées conformément à notre Politique de confidentialité et au RGPD.",
      },
    ],
  },
  {
    title: "Cookies",
    items: [
      {
        label: "Utilisation",
        value:
          "Ce site utilise des cookies techniques nécessaires à son fonctionnement. Consultez notre Politique de cookies pour plus de détails.",
      },
    ],
  },
];

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-slate-50">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-sky-600">
            LÉGAL
          </p>
          <h1 className="mt-3 text-4xl font-black text-slate-950">
            Mentions légales
          </h1>
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="space-y-6">
          {SECTIONS.map((section) => (
            <div
              key={section.title}
              className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
            >
              <h2 className="text-lg font-black text-slate-950">
                {section.title}
              </h2>
              <dl className="mt-4 divide-y divide-slate-100">
                {section.items.map((item) => (
                  <div key={item.label} className="py-3 sm:grid sm:grid-cols-3 sm:gap-4">
                    <dt className="text-sm font-semibold text-slate-700">
                      {item.label}
                    </dt>
                    <dd className="mt-1 text-sm leading-7 text-slate-600 sm:col-span-2 sm:mt-0">
                      {item.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
